import { connectToStores } from 'fluxible-addons-react';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@99designs/common/components/Button';
import { Icon } from '@99designs/common/components/Icon';
import { PopoverCard } from '@99designs/common/components/PopoverCard';

import LanguageStore, { Language } from 'contest/stores/language-store';

interface CommentSuggestionsInfoButtonProps {
    language: Language;
}
interface CommentSuggestionsInfoButtonState {
    active: boolean;
}

export class CommentSuggestionsInfoButton extends Component<
    CommentSuggestionsInfoButtonProps,
    CommentSuggestionsInfoButtonState
> {
    constructor(props: CommentSuggestionsInfoButtonProps) {
        super(props);
        this.state = { active: false };
        this.toggle = this.toggle.bind(this);
        this.clear = this.clear.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', this.clear);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.clear);
    }

    clear() {
        if (this.state.active) {
            this.setState({ active: false });
        }
    }

    toggle(
        e:
            | React.MouseEvent<HTMLAnchorElement, MouseEvent>
            | React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) {
        e.preventDefault();
        e.nativeEvent.stopImmediatePropagation();

        this.setState({ active: !this.state.active });
    }

    card() {
        return (
            <div>
                <div>
                    <h5 className="heading heading--h5">
                        <FormattedMessage id="suggested_text_help_what" />
                    </h5>
                    <p
                        className={
                            'paragraph ' +
                            (this.props.language == 'en' ? ' paragraph--no-margin' : '')
                        }
                    >
                        <FormattedMessage id="suggested_text_help_what_info" />
                    </p>
                </div>

                {this.props.language != 'en' && (
                    <div>
                        <h5 className="heading heading--h5">
                            <FormattedMessage id="suggested_text_help_english" />
                        </h5>
                        <p className="paragraph paragraph--no-margin">
                            <FormattedMessage id="suggested_text_help_english_info" />
                        </p>
                    </div>
                )}
            </div>
        );
    }

    render() {
        const button = (
            <Button
                variations={['link-info']}
                onClick={this.toggle}
                icon={<Icon type={'info-1'} />}
                iconAlignment="left"
            >
                <FormattedMessage id="suggested_text_help_link" />
            </Button>
        );

        if (this.state.active) {
            return (
                <PopoverCard
                    layerSelector="#modal-overlay-layer"
                    variations={['with-padding']}
                    card={this.card()}
                    placement="bottom"
                >
                    {button}
                </PopoverCard>
            );
        } else {
            return button;
        }
    }
}

export default connectToStores(CommentSuggestionsInfoButton, [LanguageStore], ctx => {
    return {
        language: ctx.getStore(LanguageStore).getLanguage(),
    };
});



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/components/comment-suggestions-info-button.tsx